import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=3a0c1532&scoped=true&"
import script from "./Statistics.vue?vue&type=script&lang=js&"
export * from "./Statistics.vue?vue&type=script&lang=js&"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=3a0c1532&lang=scss&scoped=true&"
import style1 from "./Statistics.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0c1532",
  null
  
)

export default component.exports